var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_vm._m(0), _vm.isOnHoliday ? _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("운영하지 않는 날짜입니다")]) : !_vm.isOnBusiness ? _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("운영하지 않는 요일입니다")]) : _c('v-row', {
    staticClass: "row--x-small"
  }, [_vm.subject.isWholeDayRent ? _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2",
      "lg": "6",
      "xl": "4"
    }
  }, [_c('rental-schedule-whole-day', _vm._g(_vm._b({}, 'rental-schedule-whole-day', {
    loading: _vm.loading,
    schedules: _vm.schedules,
    schedulesOnCloud: _vm.schedulesOnCloud,
    subject: _vm.subject,
    date: _vm.date,
    limitationMet: _vm.limitationMet
  }, false), {
    add: _vm.add,
    del: _vm.del
  }))], 1) : _vm._l(_vm.subject.businessHours, function (time) {
    return _c('v-col', {
      key: time,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "2",
        "lg": "6",
        "xl": "4"
      }
    }, [_vm.isClosed(time) ? _c('time-cell-disabled', _vm._b({}, 'time-cell-disabled', {
      subject: _vm.subject,
      schedulesOnCloud: _vm.schedulesOnCloud,
      date: _vm.date,
      time: time
    }, false)) : _c('time-cell-checkbox', _vm._g(_vm._b({
      key: "".concat(_vm.subject.name, "-").concat(time)
    }, 'time-cell-checkbox', {
      schedules: _vm.schedules,
      subject: _vm.subject,
      time: time,
      date: _vm.date,
      limitationMet: _vm.limitationMet
    }, false), {
      add: _vm.add,
      del: _vm.del
    }))], 1);
  })], 2), _c('v-sheet', [_c('h5', {
    staticClass: "tit-txt my-12 my-lg-24"
  }, [_vm._v("안내사항")]), _c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey-light",
      "rounded": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-12 pa-lg-24"
  }, [_c('ul', {
    staticClass: "pl-20",
    staticStyle: {
      "list-style-type": "disc"
    }
  }, [_c('li', [_vm._v("예약승인 대기중에는 신청이 제한되며, 관리자 승인 후 예약 신청이 완료됩니다.")])])])], 1)], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-center justify-space-between mb-12 mb-lg-24"
  }, [_c('h5', {
    staticClass: "tit-txt"
  }, [_vm._v("이용시간")]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "d-flex align-center mr-12 mr-lg-26"
  }, [_c('span', {
    staticClass: "point grey-dark"
  }), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v("마감")])]), _c('div', {
    staticClass: "d-flex align-center mr-12 mr-lg-26"
  }, [_c('span', {
    staticClass: "point primary-light"
  }), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v("승인대기")])]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "point--checkbox"
  }), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v("승인대기")])])])]);
}]

export { render, staticRenderFns }